<div class="card">
  <p-table
    [hasList]="service.hasList"
    (add)="onAdd()"
    (delete)="onDelete($event)"
    (edit)="onEdit($event)"
    (onLazyLoad)="loadData($event)"
    (onPage)="pageChange($event)"
    (view)="onView($event)"
    [columns]="service.tableColumns"
    [dataKey]="'id'"
    [first]="first"
    [globalSearch]="globalSearch"
    [hasActions]="service.hasActions"
    [hasAdd]="service.hasAdd"
    [hasDelete]="service.hasDelete"
    [hasEdit]="service.hasEdit"
    [hasView]="service.hasView"
    [loading]="loading()"
    [rows]="rows"
    [selectionMode]="'single'"
    [title]="service.title"
    [totalRecords]="total"
    [value]="list"
    tableStyleClass="table table-hover"
  >
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="service.tableColumns.length">
          <p class="text-muted mb-0 text-center">
            <i class="las la-search-minus"></i>
            {{ 'RESIDENTS.NO_INVOICE' | translate }}
          </p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
